import React from 'react';
import './css_files/App.css'
import { Link, Navigate, useNavigate } from 'react-router-dom';
import './css_files/profile.css'
import axios from 'axios';
import { url } from '../weburl';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { EditPopup } from './edit-popup';
import { dogUrlGenerator } from '../../util.js/dogUrlGenerator';


const DogCard = (props) => {

    let navigate = useNavigate()
    const handleDelete = (e) => {
        e.preventDefault()
        axios
            .delete(`${url}api/dogs/${props.dog_id}`)
        console.log('deleting')
        navigate('/home')

            .catch((err) => {
                console.log("Error couldnt delete Dog");
                console.log(err.message);
            });

    }

    return (
        <div className='container-fluid align-items-center justify-content-start dog-card mb-5'>



            <div className='row align-items-center justify-content-start'>
                <Link to={`/my_dogs/${props.dog_id}/${dogUrlGenerator(props.dogname)}`}>

                    {props.dog_public_id ?
                        <img src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${props.dog_public_id}.png`}
                            className='render_card_image'></img>
                        : <img src={props.image_src}
                            className='render_card_image render_card_image_dark'></img>

                    }
                </Link>

            </div >
            <div className='row align-items-center justify-content-start bg-white pt-2'>
                <div className='col-12  text-left  align-items-center justify-content-center w-100' >

                    <div className='  '>
                        <Link to={`/my_dogs/${props.dog_id}/${dogUrlGenerator(props.dogname)}`}>
                            <p className='brand-yellow-font text-wrap my-0'>
                                {props.dogname}

                            </p>
                        </Link>

                    </div>

                    <div className=' '>
                        <p style={{ fontWeight: '400', fontSize: "12px" }} className='smallrem'>
                            {props.breed || "Breed: Unknown"}</p>


                    </div>

                    <div className='row align-items-center justify-content-end px-4 py-2 pt-3'>
                        <div className=" align-items-end">
                            <p style={{ fontWeight: '400' }} className='p-0 m-0 font-footer'>
                                {props.date_registered || "Date: Unkwown"}</p>


                            {props.ableToBeEditted && <EditPopup dog_id={props.dog_id} dogname={props.dogname} />}

                        </div>
                    </div>
                </div>
            </div >


        </div>

    )
}



export default DogCard;